var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAwb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.45837L9 9.00008M9 9.00008L2.62498 5.45837M9 9.00008V16.1251M15.75 12.0439V5.95615C15.75 5.69917 15.75 5.57068 15.7121 5.45608C15.6787 5.35469 15.6238 5.26163 15.5515 5.18312C15.4697 5.09436 15.3575 5.03196 15.1328 4.90716L9.58275 1.82383C9.37005 1.70566 9.2637 1.64657 9.15112 1.62341C9.05137 1.60291 8.94863 1.60291 8.84895 1.62341C8.7363 1.64657 8.62995 1.70566 8.41725 1.82383L2.86723 4.90716C2.64259 5.03196 2.53027 5.09436 2.44847 5.18312C2.37612 5.26163 2.32136 5.35469 2.28786 5.45608C2.25 5.57068 2.25 5.69917 2.25 5.95615V12.0439C2.25 12.301 2.25 12.4295 2.28786 12.5441C2.32136 12.6455 2.37612 12.7385 2.44847 12.817C2.53027 12.9058 2.64259 12.9682 2.86723 13.093L8.41725 16.1763C8.62995 16.2945 8.7363 16.3535 8.84895 16.3767C8.94863 16.3972 9.05137 16.3972 9.15112 16.3767C9.2637 16.3535 9.37005 16.2945 9.58275 16.1763L15.1328 13.093C15.3575 12.9682 15.4697 12.9058 15.5515 12.817C15.6238 12.7385 15.6787 12.6455 15.7121 12.5441C15.75 12.4295 15.75 12.301 15.75 12.0439Z",
    stroke: "#F70B0C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.125L5.625 3.375",
    stroke: "#F70B0C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAwb);
export default __webpack_public_path__ + "static/media/red_awb.b7c08c43c6f7f1a69be4d61cde22484a.svg";
export { ForwardRef as ReactComponent };